import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import CreateCIN from '../../components/CreateCIN';
import CustomersCINTable from '../../components/CustomersCINTable';
import useActions from '../../hooks/useActions';

const CIN = ({ match }) => {
  const { setCustomerView } = useActions();

  useEffect(() => {
    return () => {
      setCustomerView('retailers');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-100 h-100">
      <Switch>
        <Route
          path={match.url}
          exact
          render={(props) => {
            return <CustomersCINTable {...props} />;
          }}
        />
        <Route
          path={`${match.url}/:id/:first/:last`}
          exact
          render={(props) => {
            return <CreateCIN {...props} />;
          }}
        />
      </Switch>
    </div>
  );
};

export default CIN;
